export enum MarketSortSide {
  Normal = 'Normal',
  Down = 'Down',
  Up = 'Up',
}

export enum PerpetualType {
  Inverse = 'Inverse',
  USDS = 'USDS',
  Favorite = 'Favorite',
  USD = 'USD',
  mUSDT = 'mUSDT',
}
